const es = {
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    signIn: "Entrar",
    signOut: "Salir",
    profile: "Perfil",
    settings: "Configuración",
    digiAirMenuWaiterLogin: "Inicio de sesión de camarero en DigiAirMenu",
    appLogoAlt: "logotipo de digiAirMenu",
    username: "Usuario",
    password: "Contraseña",
    pinCode: "PIN",
    yourAuthenticationFailed: "La autenticación falló",
    addDAMToHomeScreen: "Añade DigiAirMenu a tu pantalla de inicio",
    addToHomeScreen: "Añadir a la pantalla de inicio",
    installDAM: "Instalar DAM",
    language: "Idioma",
    chooseLanguage: "Elegir idioma",
    pageNotFound: "Página no encontrada",
    backToDashboard: "Volver al panel",
    transferToDemo: "Cambiar a demo",
    transferToLive: "Cambiar a modo real",
    currentTable: "Tabla actual",
    table: "Mesa",
    tables: "Mesas",
    order: "Pedido",
    orders: "Pedidos",
    option: "Opción",
    additive: "Adición",
    options: "Opciones",
    additives: "Adiciones",
    empty: "Vacío",
    row: "Fila",
    count: "cantidad",
    step: "paso",
    title: "Título",
    untitledItem: "Sin título",
    createdAt: "Creado el",
    free: "Gratis",
    freeItems: "artículos gratis",
    items: "artículos",
    item: "artículo",
    itemsCountOfAll: "{{payCount}} de {{maxCount}}",
    minimum: "mínimo",
    maximum: "máximo",
    min: "mín.",
    max: "máx.",
    all: "Todos",
    unitPrice: "Precio unitario",
    email: "Correo electrónico",
    print: "Imprimir",
    printingFailed: "¡La impresión falló!",
    orderDetails: "Detalles del pedido",
    noOrders: "No hay pedidos",
    noOrdersAdded: "No se han añadido pedidos",
    noAddedItems: "No se han añadido artículos",
    loading: "Cargando",
    createOrSelectOrderAfterSelectingTable: "Primero selecciona una mesa y luego crea o elige un pedido",
    createOrSelectOrderFirst: "Primero crea o selecciona un pedido",
    customFood: "Artículo personalizado",
    customFoods: "Artículos personalizados",
    normalFoodOrDrink: "comida/bebida normal",
    customMenuItems: "Artículos personalizados del menú",
    sentToKitchen: "Enviado a cocina",
    sendToKitchen: "Enviar a cocina",
    orderDelivered: "Pedido entregado",
    orderDeliveredConfirmation: "¿Seguro que este pedido ha sido entregado?",
    selectItemsForSendingToKitchen: "Selecciona los artículos para enviar a cocina",
    type: "tipo",
    status: "estado",
    ItemDetailsAndStatus: "Detalles / estado del artículo",
    description: "descripción",
    typeAnythingYouNeed: "Escribe lo que necesites",
    paid: "pagado",
    partiallyPaid: "Parcialmente pagado",
    unpaid: "no pagado",
    pending: "Pendiente",
    canceled: "Cancelado",
    created: "Creado",
    accepted: "Aceptado",
    completed: "Completado",
    total: "Total",
    editOrderItem: "Editar artículo del pedido",
    chooseTable: "Elegir mesa",
    pickup: "Recogida",
    suspended: "Suspendido",
    processing: "En preparación",
    rejected: "Rechazado",
    delivered: "Entregado",
    ordersList: "Lista de pedidos",
    showOlderOrders: "Mostrar pedidos anteriores",
    showHistory: "Mostrar historial",
    showCanceledOrders: "Mostrar pedidos cancelados",
    showDeliveredOrders: "Mostrar pedidos entregados",
    showPaidOrders: "Mostrar pedidos pagados",
    listOfOrders: "Lista de pedidos",
    listOfolderOrRejectedOrdersTitle: "Anteriores/Rechazados",
    addNewOrder: "Añadir nuevo pedido",
    ordering: "Toma de pedido",
    availableFoods: "Artículos disponibles",
    searchByTableName: "Buscar por nombre de mesa",
    Layout: "Diseño",
    gridView: "Vista de cuadrícula",
    listView: "Vista de lista",
    Filters: "Filtros",
    availableItems: "Artículos disponibles",
    searchByFoodName: "Buscar por nombre de comida",
    allCategories: "Todas las categorías",
    noCategories: "Sin categorías",
    addFood: "Añadir artículo",
    editManualItem: "Editar artículo manual",
    addManualItem: "Añadir artículo manual",
    manualItem: "Artículo manual",
    manualItems: "Artículos manuales",
    getEmailLabel: "Introduce tu correo electrónico",
    enterValidEmailErr: "Introduce un correo electrónico válido.",
    sendEmail: "Enviar correo",
    send: "Enviar",
    sendReceiptInfo: "Enviar detalles del recibo",
    resendPaymentLink: "Reenviar enlace de pago",
    sendMenuSms: "Enviar enlace del menú",
    sendMenuLinkBySms: "Enviar enlace del menú por SMS",
    menuLinkSentSuccessfully: "El enlace del menú se envió correctamente",
    paymentLinkResentSuccessfully: "El enlace de pago se envió correctamente",
    receiverEmail: "Correo del destinatario",
    receiverPhone: "Teléfono del destinatario",
    emailIsRequired: "El correo es obligatorio",
    phoneNumberIsRequired: "El número de teléfono es obligatorio",
    emailOrPhoneIsRequired: "Se requiere correo o teléfono",
    invalidEmailFormat: "Formato de correo no válido",
    iUnderstand: "Entiendo",
    no: "No",
    yes: "Sí",
    cancel: "Cancelar",
    close: "Cerrar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    add: "Agregar",
    preview: "Vista previa",
    changeTable: "Cambiar mesa",
    saveChanges: "Guardar cambios",
    confirm: "Confirmar",
    unselectAll: "Deseleccionar todo",
    selectAll: "Seleccionar todo",
    selected: "seleccionado",
    reset: "Restablecer",
    clear: "Limpiar",
    mobileKeyboard: "Teclado móvil",
    externalDeliveryOrder: "Pedido externo de entrega",
    externalDeliveryOrderDescription: "Este pedido debe aceptarse antes de procesarlo",
    waiterDraftOrder: "Pedido creado por el camarero",
    waiterDraftOrderDescription: "Todavía puedes editar este pedido. Confírmalo cuando todo esté listo.",
    accept: "Aceptar",
    acceptOrder: "Aceptar pedido",
    confirmOrder: "Confirmar pedido",
    completeOrderSetup: "Completar pedido",
    completeOrderSetupDialogTitle: "Completa los datos de entrega y define el horario del pedido",
    acceptOrderDialogTitle: "Aceptar este pedido iniciará la preparación y avisará a cocina",
    confirmOrderDialogTitle: "Confirmar este pedido bloqueará los cambios e iniciará la preparación",
    editingLockedForCustomerOrder: "La edición está bloqueada para pedidos de clientes.",
    editingLockedForRejectedOrder: "La edición está bloqueada porque este pedido fue rechazado.",
    editingLockedAfterConfirmation: "La edición queda bloqueada tras confirmar el pedido.",
    editingPaidOrderItemLocked: "Los artículos pagados ya no se pueden cambiar.",
    editingPendingPaymentOrderItemLocked: "Este artículo no se puede cambiar mientras se procesa su pago.",
    editingSentToKitchenItemLockedByPermission: "No tienes permiso para cambiar artículos que ya se enviaron a cocina.",
    rejectOrder: "Rechazar pedido",
    rejectOrderConfirm: "¿Seguro que quieres rechazar este pedido?",
    pleaseEnterPickupTime: "Introduce una hora de recogida",
    addToOrders: "añadir a pedidos",
    cancelThisOrder: "Cancelar este pedido",
    cancelOrder: "Cancelar pedido",
    orderModeChangedToDemoInJSX: "El modo del pedido solicitado cambió a modo demo con el título '<1>Pedido {{targetOrderId}}</1>'.",
    orderModeChangedToLiveInJSX: "El modo del pedido solicitado cambió a modo real con el título '<1>Pedido {{targetOrderId}}</1>'.",
    demo: "Demo",
    demoModeIsActive: "El modo de demostración está activo",
    demoModeAlertMessage: "El modo de demostración está destinado únicamente a fines de capacitación y prueba. El operador del restaurante es el único responsable del uso del sistema y del cumplimiento de todas las normativas legales aplicables mientras el modo de demostración esté activo.",
    normal: "Normal",
    showOrderInTargetMode: "Mostrar pedido en modo {{targetMode}}",
    showOrder: "Mostrar pedido",
    incomingOrderNotificationTitle: "Nuevo pedido recibido",
    incomingOrderNotificationDescription: "Ha llegado un pedido de cliente. Usa el botón de abajo para abrirlo en segundo plano sin cerrar esta ventana.",
    yesDeleteIt: "Sí, eliminar",
    pay: "Cobrar",
    payment: "Pago",
    payments: "Pagos",
    payReport: "Informe de pagos",
    paymentOf: "Pago de",
    checkoutOperation: "Operación de cobro",
    itemsToPay: "Artículos a cobrar",
    price: "Precio",
    basicPrice: "Precio base",
    totalPrice: "Precio total",
    baseAmount: "Importe base",
    paidPrice: "Importe pagado",
    paidBy: "Pagado por",
    discount: "Descuento",
    discountAmount: "Importe del descuento",
    tipPrice: "Propina",
    totalWithTip: "Total con propina",
    amountToPay: "Importe a pagar",
    paymentAmount: "Importe del pago",
    openPaymentsStatistics: "Estadísticas de pagos abiertos",
    tip: "Propina",
    tipAmount: "Importe de la propina",
    payByCreditCard: "Pagar con tarjeta",
    payInCash: "Pagar en efectivo",
    cardTransfer: "Transferencia con tarjeta",
    checkout: "Cobro",
    transaction: "Transacción",
    noTransactionHasBeenMade: "No se ha realizado ninguna transacción",
    backToTransactionsList: "Volver a la lista de transacciones",
    transactionsHistory: "Historial de transacciones",
    transactionDetails: "Detalles de la transacción",
    transactionId: "ID de transacción",
    transactionHasBeenSentToYourEmail: "La transacción se ha enviado a tu correo",
    paymentType: "Tipo de pago",
    paymentStatus: "Estado del pago",
    ordersPrice: "Importe de los pedidos",
    totalAmount: "Importe total",
    updatedAt: "Actualizado el",
    fromTime: "Desde",
    toTime: "Hasta",
    backToOrders: "Volver a pedidos",
    tablesList: "Lista de mesas",
    backToTablesList: "Volver a la lista de mesas",
    showDetails: "Mostrar detalles",
    receiptDetailsPage: "Página de detalles del recibo",
    vat: "IVA",
    net: "Neto",
    tax: "Impuesto",
    gross: "Bruto",
    sendingEmailFailed: "¡Error al enviar el correo!",
    paymentFailed: "El pago falló",
    openPayments: "Pagos abiertos",
    openPaymentsReport: "Informe de pagos abiertos",
    report: "Informe",
    allOrderItemsHaveBeenPaid: "Todos los artículos de este pedido han sido pagados",
    noItemsHaveBeenAddedInThisOrder: "No se han añadido artículos a este pedido",
    thisItemPaymentIsAwaitingConfirmation: "El pago de este artículo está pendiente de confirmación",
    yourOrderPaymentIsAwaitingConfirmation: "Hay un pago de este pedido pendiente de confirmación",
    editableInTime: "Editable en {{minutes}}m {{seconds}}s",
    generalSettings: "Ajustes generales",
    customItems: "Artículos personalizados",
    printMethod: "Método de impresión",
    printMethodBrowser: "Ventana de impresión del navegador",
    printMethodBluetooth: "Impresora Bluetooth",
    printMethodUsb: "Impresora USB (experimental)",
    printMethodExternal: "Impresora / app externa",
    printerSize: "Tamaño de impresora",
    useExternalPrinter: "Usar impresora externa",
    autoPrint: "Impresión automática",
    autoPrintDescription: "Imprimir automáticamente al aceptar un pedido o al recibir un evento websocket de pedido pagado",
    virtualKeyboard: "Teclado virtual",
    virtualKeyboardDescription: "Usar el teclado interno de la app en campos compatibles",
    delivery: "Entrega",
    deliveryAddress: "Dirección de entrega",
    deliveryDetails: "Detalles de entrega",
    addDeliveryDetails: "Añadir detalles de entrega",
    editDeliveryDetails: "Editar detalles de entrega",
    createDelivery: "Crear entrega",
    fullAddress: "Dirección completa",
    postalCode: "Código postal",
    houseNumber: "Número",
    served: "Servido",
    doorNumber: "Número de puerta",
    apartmentEntrance: "Entrada del apartamento",
    floor: "Piso",
    extraAddressDetails: "Detalles adicionales de la dirección",
    fullName: "Nombre completo",
    dialCode: "Prefijo",
    phoneNumber: "Número de teléfono",
    contactInformationAtPickup: "Datos de contacto del receptor",
    recommended: "recomendado",
    deliverySummary: "Resumen de entrega",
    Error: "Error",
    unexpectedErrorOccurred: "Ha ocurrido un error",
    distance: "Distancia",
    duration: "Duración",
    minutes: "Minutos",
    deliveryPrice: "Precio de entrega",
    deliveryFee: "Tarifa de entrega",
    itemsPrice: "Precio de los artículos",
    totalReceipt: "Total del recibo",
    successfulDeliveryRegistration: "Entrega registrada correctamente",
    successfulSendDelivery: "Entrega enviada correctamente",
    customer: "Cliente",
    withDelivery: "Con entrega",
    deliveryItem: "Artículo de entrega",
    pickupDetails: "Detalles de recogida",
    pickupDate: "Fecha de recogida",
    pickupTime: "Hora de recogida",
    pickupDatetime: "Fecha/hora de recogida solicitada",
    pickupTimeLabel: "Hora de recogida ({{format}})",
    pickupTimeBaseLabel: "Hora base de recogida",
    pickupTimeFinalLabel: "Hora final de recogida",
    dropOffTime: "Hora de entrega",
    requestedPickupDatetime: "Fecha/hora de recogida solicitada actual",
    timePickerHour: "Hora",
    timePickerMinute: "Minuto",
    toggleTimeList: "Mostrar u ocultar lista de horas",
    orderTiming: "Horario del pedido",
    changePickupTime: "Cambiar hora de recogida",
    pleaseEnterPickupDate: "Introduce una fecha de recogida",
    normalOrderCreationUnavailableTitle: "Los pedidos normales no están disponibles actualmente",
    deliveryAndPickupOrders: "Pedidos de entrega y recogida",
    orderId: "ID del pedido",
    orderStatus: "Estado del pedido",
    waiter: "Camarero",
    fromCustomerApp: "Desde la app del cliente",
    orderType: "Tipo de pedido",
    payByLink: "Cobrar por enlace",
    sendDelivery: "Enviar entrega",
    updateDelivery: "Actualizar entrega",
    requestCourier: "Solicitar repartidor",
    sendCourierRequest: "Enviar solicitud de repartidor",
    sentToCourier: "Enviado al repartidor",
    callCourier: "Llamar al repartidor",
    somethingWentWrong: "Algo salió mal",

    checkoutPrintDataUnavailable: "Los datos del recibo de pago no están disponibles para imprimir",
    printUsingExternalDevice: "Imprimir con dispositivo externo",
    arrival: "Llegada",
    late_arrival: "Llegada tarde",
    late_pickup: "Recogida tarde",
    request_new_driver: "Solicitar nuevo conductor",
    shipment_destroyed: "Envío dañado",
    address_not_found: "Dirección no encontrada",
    late_completed: "Completado con retraso",
    isPaid: "Está pagado",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "¿Seguro que quieres convertir el pedido <1>{{orderId}}</1> en un pedido de demostración?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "¿Seguro que quieres convertir el pedido <1>{{orderId}}</1> en un pedido real?",
    areYouSureYouWantToSwitchToLiveMode: "¿Seguro que quieres cambiar al modo real?",
    areYouSureYouWantToSwitchToDemoMode: "¿Seguro que quieres cambiar al modo de demostración?",
    areYouWantDeleteThisItem: "¿Seguro que quieres eliminar este artículo?",
    areYouWantCancelOrder: "¿Seguro que quieres cancelar este pedido?",
    receiverEmailPlaceholder: "ejemplo@email.com",
    acceptOrderExternalDescription: "Este pedido llegó desde fuera. Acéptalo para iniciar la preparación o recházalo si no puedes atenderlo.",
    confirmOrderWaiterCreatedDescription: "Este pedido fue creado por el camarero. Revísalo y confírmalo cuando todos los artículos estén listos.",
    acceptOrderWaiterCreatedDescription: "Este pedido fue creado por el camarero. Acéptalo para bloquear cambios e iniciar la preparación.",
    editingLockedCustomerOrderAfterAcceptance: "La edición de pedidos de cliente queda bloqueada después de aceptarlos.",
    editingDoneOrderItemLocked: "Los artículos ya terminados no se pueden cambiar.",
    acceptOrderPickupTimeHelperText: "Puedes retrasar la hora de recogida hasta <1>30 minutos</1>",
    checkoutHasPaidByPosInJSX: "El <1>cobro</1> con id <3>{{checkout_id}}</3> del <5>pedido {{order_id}}</5> se pagó correctamente por POS.",
    openOrderInBackground: "<0>Abrir</0> <1>(en segundo plano)</1>",
    paymentsIncludingDiscounts: "Pagos con descuentos incluidos",
    paymentsExcludingDiscounts: "Pagos sin descuentos",
    paymentsTakingIntoAccountTheirDiscount: "Pagos teniendo en cuenta su descuento",
    paymentsRegardlessOfTheirDiscount: "Pagos sin tener en cuenta su descuento",
    discountCannotBeLessThanZero: 'El descuento no puede ser menor que "0"',
    discountCannotBeNegative: "El descuento no puede ser negativo",
    discountCannotBeMoreThanHundredPercent: 'El descuento no puede ser mayor que "100%"',
    discountCannotBeMoreThan: "El descuento no puede ser mayor que {{price}}",
    theValueMustBeMoreThan: "El valor debe ser mayor que {{price}}",
    theValueMustBeMoreThanBaseAmount: "El valor debe ser mayor que el importe base",
    valueMustBeLessThanOrEqualToMessage: "El valor debe ser menor o igual que {{maxPrice}}",
    valueMustBeGreaterThanZeroMessage: "El valor debe ser mayor que 0",
    tipCannotBeNegative: "El importe de la propina no puede ser negativo",
    checkoutQrCodeAlt: "Código QR de cobro",
    Open_Payments: "Pagos abiertos",
    openPaymentStatistics: "Estadísticas de pago abierto",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Este artículo se pagó por POS y espera confirmación del pago",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Este pedido se pagó por POS y espera confirmación del pago",
    singlePrintMethodDescription: "Solo puede estar activo un método de impresión a la vez",
    bluetoothUnavailable: "Bluetooth no está disponible en este navegador o dispositivo",
    bluetoothSecureContextRequired: "La impresión por Bluetooth requiere HTTPS o localhost",
    bluetoothPrinterNotSupported: "La impresora Bluetooth seleccionada no es compatible",
    noBluetoothPrinterSelected: "No se seleccionó ninguna impresora Bluetooth",
    noCompatibleBluetoothPrinterFound: "No se encontró ni seleccionó una impresora Bluetooth compatible. Los navegadores suelen detectar solo impresoras BLE/GATT, así que modelos Bluetooth clásicos como Epson TM-m30 pueden no aparecer aquí",
    bluetoothAutoPrintRequiresSelection: "Selecciona manualmente una impresora Bluetooth una vez antes de usar la impresión automática",
    bluetoothPrintingNotSupported: "La impresión por Bluetooth no es compatible con este navegador o dispositivo",
    usbUnavailable: "USB no está disponible en este navegador o dispositivo",
    usbSecureContextRequired: "La impresión por USB requiere HTTPS o localhost",
    noCompatibleUsbPrinterFound: "No se encontró ni seleccionó una impresora USB compatible",
    usbAccessDenied: "El navegador o el sistema operativo denegó el acceso a la impresora USB seleccionada. Cierra otras apps de impresión y revisa los permisos USB del sistema, luego inténtalo de nuevo",
    usbAutoPrintRequiresSelection: "Selecciona manualmente una impresora USB una vez antes de usar la impresión automática",
    usbPrintingNotSupported: "La impresión USB no es compatible con el dispositivo seleccionado",
    bluetoothPrinterDetails: "Puedes enviar impresiones a impresoras Bluetooth o desactivarlo para elegir una impresora conectada a este dispositivo",
    usbPrinterDetails: "Soporte experimental para impresoras USB compatibles con ESC/POS en Chrome o Edge de escritorio. Puede que tengas que seleccionar la impresora manualmente una vez antes de usar la impresión automática. En Windows, la impresora también puede necesitar modo Vendor Class y un controlador compatible con WinUSB para aparecer en el navegador",
    externalPrinterDetails: "Puedes enviar impresiones a impresoras externas conectadas a la app o desactivarlo para elegir una impresora conectada a este dispositivo",
    autoPrintUnavailableForBrowserDescription: "La impresión automática no está disponible con el diálogo de impresión del navegador",
    browserPrintMethodNotice: "El diálogo de impresión del navegador siempre requiere confirmación, por eso los recibos no pueden imprimirse automáticamente",
    selectAllPayablesByDefault: "Seleccionar todos los cobrables por defecto",
    selectAllPayablesByDefaultOnThePaymentPage: "Seleccionar por defecto todos los artículos cobrables en la página de pago",
    virtualKeyboardInfoLabel: "Ayuda del teclado",
    virtualKeyboardDisableHint: "Si prefieres el teclado del dispositivo, puedes desactivar este teclado en <0>Configuración</0>.",
    pickupTimeInitialShort: "Base",
    maximumSelectableFreeCountHint: "Cantidad máxima que puede seleccionarse gratis",
    minimumSelectableCountHint: "Cantidad mínima seleccionable",
    maximumSelectableCountHint: "Cantidad máxima seleccionable",
    maximumSelectedItemsReached: "Se alcanzó el número máximo de artículos seleccionados",
    pickupTimeAllowedRangeHint: "Para {{date}}, la hora de recogida se puede elegir de {{start}} a {{end}}.",
    pickupDatetimeNotSetHint: "Aún no se ha definido fecha/hora de recogida. Puedes elegir cualquier hora de recogida.",
    pickupDatetimeLimitedDelayHint: "Esta fecha/hora de recogida solicitada se puede retrasar hasta <1>30 minutos</1> mientras el pedido siga pendiente de aceptación.",
    pickupDatetimeLockedHint: "Este pedido ya tiene una fecha/hora de recogida definida.",
    pickupTimeEditableOnlyWhenSuspended: "La hora de recogida solo se puede cambiar cuando el pedido está suspendido.",
    pickupDateMustBeTodayOrTomorrow: "Para pedidos creados por camarero, la fecha de recogida debe ser hoy o mañana.",
    normalOrderCreationClosedAllDay: "El restaurante está cerrado este día, por lo que no se pueden crear pedidos.",
    normalOrderCreationClosedAtThisTime: "El restaurante está cerrado ahora. Los pedidos se pueden crear durante el horario de apertura: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "No hay ningún horario válido de {{orderType}} dentro del horario del restaurante para las fechas permitidas actualmente.",
    pickupDateOutsideOpeningHours: "La fecha seleccionada está fuera de los días permitidos para pedidos de {{orderType}}.",
    pickupTimeOutsideOpeningHours: "La hora seleccionada está fuera del horario permitido para pedidos de {{orderType}}.",
    openingHoursSelectableRangeHint: "Para {{date}}, la hora de {{orderType}} se puede elegir entre {{start}} y {{end}}.",
    openingHoursClosedDayHint: "{{date}} está cerrado para pedidos de {{orderType}}.",
    openingHoursClosedDayCalendarHint: "Cerrado para este tipo de pedido",
    openingHoursDisabledDatesHint: "Solo se pueden elegir fechas con al menos una hora de {{orderType}} disponible dentro del horario del restaurante.",
    openingHoursUnavailableTimesHint: "Las horas que no se pueden elegir están fuera del horario del restaurante para pedidos de {{orderType}} en la fecha seleccionada.",
    noPickupTimeProvidedForThisOrder: "No se indicó hora de recogida para este pedido",
    pickupTimeCalculationForThisOrderFailed: "No se pudo calcular la hora de recogida de este pedido",
    itemEditFailed: "No se pudo editar el artículo",
    thisItemCannotBeEdited: "Este artículo no se puede editar.",
    problemInReadingItemEssentialDataMessage: "Hubo un problema al leer la información esencial del artículo",
};

export default es;
